import { render, staticRenderFns } from "./job-form-specs-delivery-categories.vue?vue&type=template&id=5c62d2fe&scoped=true"
import script from "./job-form-specs-delivery-categories.vue?vue&type=script&lang=js"
export * from "./job-form-specs-delivery-categories.vue?vue&type=script&lang=js"
import style0 from "./job-form-specs-delivery-categories.vue?vue&type=style&index=0&id=5c62d2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62d2fe",
  null
  
)

export default component.exports